/**
 * Created by asiulik on 30.11.2017.
 */



define(function(){

    function FilterTag(){}

    FilterTag.prototype.check = function(){}

    return {
        FilterTag: FilterTag
    }

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filterTags.js